import React from 'react'
import { arrayOf, string, number } from 'prop-types'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Box, Button, Grid, Footer } from '@cobalt/cobalt-react-components'
import {
  RECOVERY_OTP_PRINT_TITTLE,
  RECOVERY_OTP_DOWNLOAD_BUTTON,
  RECOVERY_OTP_PRINT_BUTTON,
  RECOVERY_OTP_COPY_BUTTON,
  RECOVERY_OTP_TEXT_FILE_NAME,
  RECOVERY_OTP_TEXT_FILE_TITLE
} from '../../constants/ui.labels'
import RecoveryOTPList from '../RecoveryOTPList'

class RecoveryOTPBox extends React.Component {
  state = { copyButtonState: null }

  buildOTPList = otpList =>
    RECOVERY_OTP_TEXT_FILE_TITLE.concat(otpList.join('\n'))

  downloadCodes = otpList => {
    const file = new Blob([this.buildOTPList(otpList)], {
      type: 'text/plain'
    })

    const element = document.createElement('a')
    element.href = URL.createObjectURL(file)
    element.download = RECOVERY_OTP_TEXT_FILE_NAME
    element.click()
  }

  changeCopyButtonState = () => {
    this.setState({ copyButtonState: Button.SUCCESS_STATE })

    setTimeout(
      () => this.setState({ copyButtonState: null }),
      this.props.copySuccessFeedbackDuration
    )
  }

  render() {
    const { otpList } = this.props
    return (
      <Box>
        <Box.Content>
          <h2 className="print-only">{RECOVERY_OTP_PRINT_TITTLE}</h2>
          <RecoveryOTPList otpList={otpList} />
        </Box.Content>
        <Footer transparent>
          <Grid gridFluid noPadding>
            <Grid.Group
              fullHeight
              horizontalGutters={Grid.Group.HALF_HORIZONTAL_GUTTERS}
            >
              <Grid.Column all="33" medium="33" small="33">
                <Button
                  small
                  secondary
                  fullWidth
                  onClick={() => this.downloadCodes(otpList)}
                >
                  {RECOVERY_OTP_DOWNLOAD_BUTTON}
                </Button>
              </Grid.Column>
              <Grid.Column all="33" medium="33" small="33">
                <Button small secondary fullWidth onClick={window.print}>
                  {RECOVERY_OTP_PRINT_BUTTON}
                </Button>
              </Grid.Column>
              <Grid.Column all="33" medium="33" small="33">
                <CopyToClipboard text={this.buildOTPList(otpList)}>
                  <Button
                    small
                    secondary
                    fullWidth
                    onClick={this.changeCopyButtonState}
                    state={this.state.copyButtonState}
                  >
                    {RECOVERY_OTP_COPY_BUTTON}
                  </Button>
                </CopyToClipboard>
              </Grid.Column>
            </Grid.Group>
          </Grid>
        </Footer>
      </Box>
    )
  }
}

RecoveryOTPBox.propTypes = {
  otpList: arrayOf(string),
  copySuccessFeedbackDuration: number.isRequired
}

RecoveryOTPBox.defaultProps = {
  copySuccessFeedbackDuration: 2000
}

export default RecoveryOTPBox
